import React from 'react'
import "./BlogPost.css";

import ny from "../../Assets/b63/ny.jpg"

function Blog63() {
    return (
        <div className='container-fluid my-5'>
            <div className='row mb-5'>
                <div className='col blog-text text-center'>
                    <h1>HAPPY NEW YEAR 2026! 🎉</h1>
                    <h6>January 08, 2026 at 10:00 AM</h6>
                </div>
            </div>

            <div className='row align-items-center justify-content-center mx-5 gx-5 gy-5'>
                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-5 col-xxl-5'>
                    <img src={ny} className="blog-img" alt="..." />
                </div>
                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 blog-text'>
                    <p>Cheers to a New Year filled with new beginnings, exciting adventures, fresh starts, and endless possibilities. 
                        May this coming year bring growth, happiness, and success to us all. Happy New Year to everyone. Here’s to moving forward with hope and gratitude!</p>
                    <p><a href='https://www.facebook.com/hashtag/mytsoftdevsolutions' target='_blank' className='blog-link'>
                        #MYTSoftDevSolutions </a>
                        <a href='https://www.facebook.com/hashtag/techforgood' target='_blank' className='blog-link'>
                        #TechForGood </a>
                        <a href='https://www.facebook.com/hashtag/builttolast' target='_blank' className='blog-link'>
                        #BuildToLast </a>
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Blog63;
